import { handleActions } from 'redux-actions';
import * as vehicleCardActions from '../actions/vehicleCard';

let initState = {
  isLoading: false,
  isFetching: false,
  errorMessage: '',
  data: null,
  errors: null,
  success: null
};

export const VehicleCard = handleActions(
  {
    //Get Vehicle Id
    [vehicleCardActions.getVehicleById]: state => {
      return { ...state, isLoading: true };
    },
    [vehicleCardActions.getVehicleByIdSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        data: payload,
        isLoading: false,
      };
    },
    [vehicleCardActions.getVehicleByIdError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        isLoading: false,
      };
    },
    // Create Vehicle
    [vehicleCardActions.createVehicle]: state => {
      return { ...state, isFetching: true };
    },
    [vehicleCardActions.createVehicleSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        data: payload,
        isFetching: false,
      };
    },
    [vehicleCardActions.createVehicleError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errors: payload.data,
        isFetching: false,
        errorMessage: payload.message
      };
    },
    // Update Vehicle
    [vehicleCardActions.updateVehicle]: state => {
      return { ...state, isFetching: true };
    },
    [vehicleCardActions.updateVehicleSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        data: payload,
        isFetching: false,
        success: state.success ? state.success + 1 : 1,
      };
    },
    [vehicleCardActions.updateVehicleError]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errors: payload.data,
        isFetching: false,
        errorMessage: payload.message
      };
    },
    // Очищаем ошибки при положительном ответе от сервера
    [vehicleCardActions.clearErrors]: (state, action) => {
      return {
        ...state,
        errors: null,
        errorMessage: null
      }
    },
  },
  initState
);
